module.exports = ".feedbackBox {\n\tpadding: 6px 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/answer_component/feedback/feedback.component.css
// module id = ./src/app/component/shared/answer_component/feedback/feedback.component.css
// module chunks = main